export const campaign = {
  candidate: 'Beau Rawlins',
  committee: 'Beau Rawlins for Galveston City Council District 5',
  office: 'Galveston City Council District 5',
  shortOffice: 'District 5',
  domain: 'votebeaurawlins.org',
  email: 'info@votebeaurawlins.org',
  officialEmail: 'beaurawlins@galvestontx.gov',
  cityPhone: '409-797-3510',
  electionDay: 'Saturday, June 13, 2026',
  electionDayName: 'Runoff Election Day',
  electionDayHours: '7:00 AM - 7:00 PM',
  runoffRace: 'District 5 runoff: Vote Beau Rawlins',
  earlyVoting: ['June 1-5: 8:00 AM - 5:00 PM', 'June 8-9: 7:00 AM - 7:00 PM'],
  earlyVotingLocations: [
    'Records and Elections Ctr, 10000 Emmett F. Lowry Expressway, Texas City',
    'Historic Galveston Water & Electric Light Community Center, 715 30th St.',
    'Moody Methodist Church, 2803 53rd St.',
  ],
  electionDayLocations: [
    'Historic Galveston Water & Electric Light Community Center, 715 30th St.',
    'Moody Methodist Church, 2803 53rd St.',
  ],
  officialElectionUrl: 'https://www.galvestontx.gov/266/Election',
  facebookUrl:
    'https://www.facebook.com/pages/category/Political-Candidate/Beau-Rawlins-For-Galveston-City-Council-District-5-100411771562607',
  galvestonVotesUrl: 'https://www.galvestonvotes.org/',
  cityProfileUrl: 'https://galvestontx.gov/412/District-5---Beau-Rawlins',
  contactEndpoint: 'https://api.southcoaststrategy.com',
  paidFor: 'Political advertising paid for by Beau Rawlins for Galveston City Council District 5.',
};

export const assets = {
  headshot: '/assets/beau/beau-rawlins-headshot-2026.jpg',
  logo: '/assets/beau/beau-rawlins-logo-2026.png',
  candidateCard: '/assets/beau/beau-rawlins-goodparty.jpg',
  adPrimary: '/assets/beau/beau-campaign-ad-1.jpg',
  adSecondary: '/assets/beau/beau-campaign-ad-2.jpg',
  adTertiary: '/assets/beau/beau-campaign-ad-3.jpg',
  publicSafety: '/assets/beau/public-safety-context.jpg',
  communityOne: '/assets/beau/galveston-community-1.jpg',
  communityTwo: '/assets/beau/galveston-community-2.jpg',
};

export const smsConsentText =
  'Optional SMS opt-in: If you provide your phone number and check this box, you consent to receive manually sent political text messages from the Beau Rawlins Campaign. Message frequency varies. Message and data rates may apply. Reply STOP to opt out and HELP for help. Donations may be solicited. Consent is not a condition of donating, volunteering, or receiving campaign information. See our Privacy Policy and Terms and Conditions.';

export const researchNotes = {
  cityService:
    'Elected to Galveston City Council District 5 in 2024. Current term expires in May 2026.',
  runoff: 'The City of Galveston lists a June 13, 2026 runoff election for District 5.',
  priorEndorsements: [
    'Galveston Municipal Police Association',
    'Galveston Firefighters Association',
    'Senator Mayes Middleton',
    'State Representative Terri Wilson',
    'County Commissioner Joe Giusti',
  ],
};
